<template>
  <qz-results-details
    :quote="quote"
    :is-view-monthly="isViewMonthly"
    :is-buy-online-disabled="isBuyOnlineDisabled"
    :details-description="detailsDescription"
    :selected-optional-extras="selectedOptionalExtras"
    :is-details-drawer-open="isDetailsDrawerOpen"
    :filter-extras="filterExtras"
    :quote-position-number="quotePositionNumber"
    @go-to-form="$emit('go-to-form')"
    @re-quote="$emit('re-quote')"
    @close-drawer="$emit('close-drawer')"
    @open-drawer-details="$emit('open-drawer-details', ['details-description', 'estimatedPrice'])"
  >
    <!-- TELEMATICS -->
    <template
      v-if="hasTelematics"
      #how-to-buy
    >
      <div class="mb-4">
        <v-checkbox
          v-model="telematicsChecked"
          class="buy-online-checkbox mb-2"
          hide-details
        >
          <span
            slot="label"
            v-html="telematicsCheckLabel"
          />
        </v-checkbox>

        <a
          href="#"
          class="body-2"
          @click.prevent="showTelematicsDetails"
        >
          What is telematics?
        </a>
      </div>
    </template>

    <template #policy-excess>
      <h4 class="mb-3">
        This policy excess is split into two parts:
      </h4>
      <v-simple-table
        dense
        class="theme--light light"
      >
        <template #default>
          <tbody>
            <tr>
              <th>Compulsory excess</th>
              <td class="text-right">
                &pound;{{ quoteDetails.compulsoryExcess }}
              </td>
            </tr>
            <tr>
              <th>Voluntary excess</th>
              <td class="text-right">
                &pound;{{ quoteDetails.voluntaryExcess }}
              </td>
            </tr>
            <tr>
              <th>Total excess</th>
              <td class="text-right">
                &pound;{{ parseInt(quoteDetails.compulsoryExcess) + parseInt(quoteDetails.voluntaryExcess) }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </qz-results-details>
</template>

<script>
import QzResultsDetails from '@/components/QzResults/QzResultsDetails';
import { isEmpty } from 'lodash';

export default {
  name: 'results-details',
  components: {
    QzResultsDetails,
  },
  props: {
    quote: {
      required: false,
      type: Object,
      default: undefined,
    },
    isViewMonthly: {
      type: Boolean,
      required: true,
    },
    detailsDescription: {
      type: Object,
      required: true,
    },
    selectedOptionalExtras: {
      type: Array,
      required: true,
    },
    isDetailsDrawerOpen: {
      type: Boolean,
      required: true,
    },
    quotePositionNumber: {
      required: true,
      type: Number,
    },
  },
  data: () => ({
    telematicsChecked: false,
  }),
  computed: {
    quoteDetails () {
      return this.quote?.details?.[0] || null;
    },
    isBuyOnlineDisabled () {
      const isTemporarilyDisabled = [
        // 3632,
        // 3633,
        // 3636,
        // 3822,
      ].includes(this.quote?.site_id);
      return isTemporarilyDisabled || (!this.telematicsChecked && this.hasTelematics);
    },
    hasTelematics () {
      return (this.quoteDetails?.telematicsDetails && this.quoteDetails?.telematicsDetails.isTelematics === 'Y');
    },
    telematicsCheckLabel () {
      // proper special offers are listed in companyConfig / featuredText
      return this.quoteDetails.telematicsDetails.text ? this.quoteDetails.telematicsDetails.text.replace(/<br ?\/?>/g, '\n') : 'This quote is based on usage of a telematics device, please tick if this ok.';
    },
  },
  watch: {
    isDetailsDrawerOpen () {
      this.telematicsChecked = false;
    },
  },
  methods: {
    showTelematicsDetails () {
      this.$emit('open-drawer-details', ['details-description', 'telematics']);
    },
    filterExtras (condition) {
      const accumulator = {};
      Object.keys(this.quoteDetails.optionalExtra).forEach((cover) => {
        if (this.quoteDetails.optionalExtra[cover].included === condition && this.quoteDetails.optionalExtra[cover].description !== 'DO_NOT_SHOW') {
          accumulator[cover] = this.quoteDetails.optionalExtra[cover];
        }
      });
      return isEmpty(accumulator) ? null : accumulator;
    },
  },
};
</script>
